module.exports = __webpack_public_path__ + "assets/dae3db33c332db576ed21a483ceb62da.png";